interface DisclaimerFields {
  generated_by?: string | null
  signed_by?: string | null
}

interface OrgWithDisclaimer {
  process_settings?: { protection_disclaimer?: DisclaimerFields | null } | null
  representative_of_org?: { process_settings?: { protection_disclaimer?: DisclaimerFields | null } | null } | null
}

/**
 * Resolves the effective Protection Waiver Declaration disclaimer for display.
 * An AR that has not defined its own generated_by/signed_by inherits the parent DA's disclaimer
 * (display-only — used to seed form initial values, never persisted onto the AR unless overridden).
 */
export const resolveInitialProtectionDisclaimer = (
  org: OrgWithDisclaimer | null | undefined,
): DisclaimerFields | undefined => {
  if (!org) return undefined

  const own = org.process_settings?.protection_disclaimer
  if (own?.generated_by || own?.signed_by) return own

  const parent = org.representative_of_org?.process_settings?.protection_disclaimer
  if (parent?.generated_by || parent?.signed_by) return parent

  return own ?? undefined
}
